<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <p class="flex-grow-1">{{ $t('keyValue') }}</p>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <!-- Form -->
                <!-- Key -->
                <div role="group" class="form-group">
                <label class=""> {{ $t('keyMandatory') }}</label>
                    <CInput type="text" v-model="keyValue.key" :invalid-feedback="errorOutput['Key']" :is-valid="genericValidator(keyValue.key, attemptedSubmit) && errorValidator('Key')"></CInput>
                </div>
                <!-- Values -->
                <div role="group" class="form-group">
                    <label class=""> {{ $t('descriptionsMandatory') }}</label>
                    <vue-editor v-model="keyValue.values[currentLanguage.key]" v-bind:class="{'is-invalid': genericValidator(keyValue.values, attemptedSubmit) === false || errorValidator('Values') }"></vue-editor>
                    <div v-if="errorOutput.Values" class="invalid-feedback">{{errorOutput.Values}}</div>
                </div>
                <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary col-2 align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState } from 'vuex'
import router from '@/router/index';
import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";
import KeyValue from "@/classes/KeyValue";
import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import { VueEditor } from "vue2-editor";
import FormLoading from '@/controls/FormLoading.vue'

  export default {
        components: { LanguageDropdown, ConfirmationPopUp, VueEditor, FormLoading },
    props:{    
        baseKeyValue:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            keyValue: new KeyValue('', {}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetKeyValue();
    },
    computed:
    {
        ...mapState('keyValues', ['putKeyValueOutput']),
        ...mapState('keyValues', ['postKeyValueOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate multi language fields
            for (const [key, value] of Object.entries(this.keyValue.values)) { if(!value) { result['Values'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        name: function () {
            return this.baseKeyValue || this.baseName ? (this.baseKeyValue ? this.baseKeyValue.name : this.baseName) : null;
        }
    },
    methods:{
        genericValidator,
        errorValidator,
        resetKeyValue(){
            if(!this.baseKeyValue)
            {
                var values = {}; 
                CONSTANTS.supportedLanguages.forEach(language => { values[language.key] = "";  });
                this.keyValue = new KeyValue('', values);
            }
            else
            {
                this.keyValue = deepClone(new KeyValue, this.baseKeyValue);    
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // Emit event
            if(this.keyValue.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.keyValue);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({name: 'KeyValuesList'});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        putKeyValueOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postKeyValueOutput: function(val)
        {
            this.onProcessTask(val);
        },
        baseKeyValue: function()
        {
            this.resetKeyValue();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}
</style> 